// extracted by extract-css-chunks-webpack-plugin
module.exports = {"animate":"animate_jBdiv","peek":"peek_MS1Jg"};